/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-unused-expressions */
import React from 'react';
import PropTypes from 'prop-types';
import { globalHistory } from '@reach/router';
import useTranslate from '~hooks/useTranslate/useTranslate';
import { prettyTracker } from '~helpers/getters';
import { setCookie } from '~helpers/cookies';
import { getTrackingAPIParams, trackerLinkActive } from '~helpers/tracker';
import keygen from '~helpers/keygen';
import styles from './button.module.scss';

const OperatorCtaButton = ({
  operator,
  pageTemplate = null,
  gtmClass = '',
  buttonType = 'primary',
  buttonSize = '',
  moduleName = null,
  clickedElement="cta",
  tracker = 'main',
  titleSuffix,
  icon = null,
  translationsObj = {
    active: { translationKey: 'play_now', defaultValue: 'Visit' },
    not_recommended: {
      translationKey: 'not_recommended',
      defaultValue: 'Not Recommended'
    },
    coming_soon: {
      translationKey: 'coming_soon',
      defaultValue: 'Soon Available'
    },
    inactive: {
      translationKey: 'inactive',
      defaultValue: 'Not Accepting New Players'
    },
    blacklisted: { translationKey: 'blacklisted', defaultValue: 'Blacklisted' }
  },
  rel = 'nofollow sponsored',
  modulePosition,
  itemPosition
}) => {
  const status = operator?.status || ''
  const trackerType = tracker?.toLowerCase()?.replace(' ', '_')
  const referer =
    typeof document !== 'undefined' && document?.referrer
      ? document.referrer
      : '';

  const prettyLink = `${prettyTracker(
    operator,
    trackerType,
    false
  )}`

  const translateBtn =
    status && translationsObj[status]
      ? // eslint-disable-next-line react-hooks/rules-of-hooks
      useTranslate(
        translationsObj[status]?.translationKey,
        translationsObj[status]?.defaultValue || ''
      )
      : 'Claim'

  const affObject = JSON.stringify(
    getTrackingAPIParams(
      pageTemplate,
      moduleName,
      tracker,
      clickedElement,
      globalHistory.location.href,
      referer,
      modulePosition,
      itemPosition
    )
  )

  const onCTAClick = () => {
    process.env.IS_TRACKING_SSR &&
      setCookie(
        'affObject',
        affObject,
        1,
        '/'
      )

    if (process.env.ENABLE_PIXEL === 'true' && typeof window.fbq !== 'undefined') {
      // Call fbq track event
      window.fbq('track', 'InitiateCheckout', { keyID: keygen() })
    }
  }

  const classes = `${styles[buttonType] || ''} ${status && styles[status] ? styles[status] : ''} ${buttonSize ? styles[`${buttonSize}_size`] : ''
    } `;

  return (
    trackerLinkActive(operator, tracker) &&
    (status === "active" ? (
      <a
        href={prettyLink || "#"}
        title={`${typeof translateBtn === "string" ? translateBtn : ""} ${titleSuffix || ""
          }`.trimEnd()}
        aria-label={`${typeof translateBtn === 'string' ? translateBtn : ''} ${titleSuffix || ''
          }`.trimEnd()}
        className={`${classes} ${gtmClass}`}
        target="_blank"
        rel={rel}
        onClick={onCTAClick}
      >
        {translateBtn}
        {icon && icon}
      </a>
    ) : (
      <div
        title={`${typeof translateBtn === 'string' ? translateBtn : ''} ${titleSuffix || ''
          }`.trimEnd()}
        className={`${classes || ''} ${gtmClass || ''}`}
      >
        {translateBtn}
        {icon && icon}
      </div>
    ))
  )
}

OperatorCtaButton.propTypes = {
  operator: PropTypes.shape({
    name: PropTypes.string,
    status: PropTypes.string,
  }),
  titleSuffix: PropTypes.string,
  gtmClass: PropTypes.string,
  pageTemplate: PropTypes.string,
  buttonSize: PropTypes.string,
  buttonType: PropTypes.string,
  tracker: PropTypes.string,
  moduleName: PropTypes.string,
  clickedElement:  PropTypes.string,
  translationsObj: PropTypes.shape({
    active: PropTypes.shape({
      translationKey: PropTypes.string,
      defaultValue: PropTypes.string
    }),
    not_recommended: PropTypes.shape({
      translationKey: PropTypes.string,
      defaultValue: PropTypes.string
    }),
    coming_soon: PropTypes.shape({
      translationKey: PropTypes.string,
      defaultValue: PropTypes.string
    }),
    inactive: PropTypes.shape({
      translationKey: PropTypes.string,
      defaultValue: PropTypes.string
    })
  }),
  icon: PropTypes.node,
  rel: PropTypes.string,
  modulePosition: PropTypes.number,
  itemPosition: PropTypes.number,
}

export default OperatorCtaButton
